import { Injectable, OnDestroy } from '@angular/core';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { CookieService } from 'ngx-cookie-service';
import { CmsConfig } from '../config/cms.config';
// tslint:disable-next-line:nx-enforce-module-boundaries
import { CookieConsentDialogComponent } from '../../../../lr-ui/src/lib/dialogs/cookie-consent-dialog/cookie-consent-dialog.component';
import { from } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SubSink } from 'subsink';

@Injectable({
  providedIn: 'root'
})
export class TrackingService implements OnDestroy{

  private subSink: SubSink;

  constructor(
    private gtmService: GoogleTagManagerService,
    private cookieService: CookieService,
    private cmsConfig: CmsConfig,
    private ngbModal: NgbModal
  ) {
    this.subSink = new SubSink();
  }

  removeModal(): void {
   if (this.ngbModal.hasOpenModals()) {
     this.ngbModal.dismissAll();
   }
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

  addGtmToDom(): void {
    if (this.cookieService.get('cookie-consent')) {
      if (this.cookieService.get('marketing')) {
        this.gtmService.addGtmToDom().then(() => { });
        const gtmTag = {
          event: 'pageView'
        };
        this.gtmService.pushTag(gtmTag).then(() => { });
      }
      return;
    }
    if (!this.ngbModal.hasOpenModals()) {
      const dialogRef = this.ngbModal.open(CookieConsentDialogComponent);
      this.subSink.sink = from(dialogRef.result).subscribe(
        (result: {essential: boolean}) => {
          this.setCookieForTacking(result.essential);
          const gtmTag = {
            event: 'cookie_consent_set'
          };
          this.gtmService.pushTag(gtmTag).then(() => { });
          window.location.reload();
        }
      )
    }
  }

  private setCookieForTacking(essential: boolean): void {
    if (!essential) {
      this.cookieService.set('cookie-consent', 'analytics-and-marketing', 365 * 2, this.cmsConfig.basePath, null, true, "Strict");
      this.cookieService.set('marketing', 'true', 365 * 2, this.cmsConfig.basePath, null, true, "Strict");
      return
    }
    this.cookieService.set('cookie-consent', 'essential', 365 * 2, this.cmsConfig.basePath, null, true, "Strict");
  }
}
